<template>
  <header :class="{'top-searchbar':true, 'flex-box':true}" v-if="$store.state.platform !== 'iOS'&&$store.state.platform !== 'Android'">
    <div class="back" v-if="goBack" @click="$route.query.platform?bridges.GoBack():back()">
      <i class="iconfont icon-weixin_fanhuishangye"></i>
    </div>
    <div class="back" v-if="goSaveBack" @click="goSave">
      <i class="iconfont icon-weixin_fanhuishangye"></i>
    </div>
    <div class="park-back" v-if="goPark" @click="goToPark">
      <img class="icon-img" src="../assets/img/logo1.png" alt="">
      <p>返回</p>
    </div>
    <slot class="back" name="back"></slot>
    <!--叉叉-->
    <div class="back" v-if="goBackFork" @click="$route.query.platform?bridges.GoBack():back()">
      <i class="iconfont icon-icon-"></i>
    </div>
    <div class="back" v-if="bridgeBack"  @click="bridges.GoBack">
      <i class="iconfont icon-back1"></i>
    </div>
    <div class="title-head ellipsis" v-if="headTitle">
      {{headTitle}}
    </div>
    <slot name="tit-right"></slot>
    <slot name="icon"></slot>
    <slot name="jifenrule"></slot>
  </header>
</template>

<script>
  import {mapState, mapActions, mapMutations} from 'vuex'
  import * as getData from '../service/getData'
  export default {
    data () {
      return {

      }
    },
    created () {
      //console.log(this.$store.state.platform)
    },
    props: ['searchKey', 'headTitle', 'goBack', 'bridgeBack', 'goBackFork', 'serviceGet', 'goSaveBack', 'goPark'],
    computed: {

    },

    methods: {
      back () {
        this.$router.go(-1)
      },
      goToPark () {
        window.location.href = this.$store.state.channelApiUrl + '#/index';
      },
      goSave () {
        if (this.$route.query.isCourseReckon) {
          let data = {
            courseId: this.$store.state.courseDetail.courseId,
            courseDetailId: this.$store.state.courseDetail.courseDetailId,
            coursewareId: this.$store.state.courseDetail.detail.coursewareId,
            coursewareState: 0,
            learnTime: '',
          };
          const learnTime = (new Date() - this.$store.state.courseStartTime) / 60000;
          data.learnTime = Math.floor(learnTime);
          if (learnTime >= Number(this.$store.state.courseDetail.detail.coursewareTime)) {
            data.coursewareState = 1;
          }
          getData.addMyCourseTime(data).then(res => {
            if (res.data.code !== 1) {
              this.$dialog.toast({mes: res.data.message});
              return
            }
            this.$store.state.courseStartTime = '';
            this.$store.state.courseDetail = {};
            this.$store.state.courseWareUrl = '';
            if (this.$route.query.platform) {
              this.bridges.GoBack();
            } else {
              this.back();
            }
          }).catch(err => {
            console.log(err);
            this.$dialog.toast({mes: '服务器连接出错，请检查网络'});
          })
        }
      },
    },
    components: {
    }
  }
</script>
<style scoped lang="scss">
  @import '../assets/css/mixin';
  .top-searchbar{
    position: relative;
    z-index: 200;
    height: .88rem;
    background-color: #D60000;
    .back{
      padding: 0.1rem 0.23rem;
      i{
        @include sc(.37rem,#fff);
        &.icon-icon-{
          font-size: .3rem;
        }
      }
    }
    .title-head{
      @include cl;
      line-height: .5rem;
      width: 50%;
      text-align: center;
      @include sc(0.36rem, #FFFFFF);
    }
  }
  .park-back{
    @include fj();
    align-items: center;
    margin-left: .2rem;
    height: .66rem;
    padding: 0 .2rem;
    border-radius: .33rem;
    background: #a50012;
    border: #920012 1px solid;
    .icon-img{
      @include wh(.4rem,.4rem);
      margin-right: .1rem;
    }
    p{
      line-height: .8rem;
      @include sc(0.22rem, #FFFFFF);
    }
  }
</style>



// WEBPACK FOOTER //
// header.vue?2cf99d5a